/* src/app/views/collection/components/edit-collection/edit-collection.component.scss */
/*# sourceMappingURL=edit-collection.component.css.map */
